import { ModelCommon, UserAttributeDef, UserAttributeDefs, toDatePickerFormat, ValidModelType } from '@iotv/datamodel-core';
import { isValidBusinessObject, MapLike, PathDirection } from '@iotv/iotv-v3-types';

const typeName = 'NitrateReadings';

export type NitrateReadingsProps = {
  nitrateLevel?: number;
  nitrateChanges?: number;
  waterTemperature?: number;
};

export class NitrateReadings extends ModelCommon {
  constructor(ob: any) {
    super(ob.type || typeName, ob);
  }

  nitrateLevel?: number;
  nitrateChanges?: number;
  waterTemperature?: number;

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      nitrateLevel: { type: 'Number', editable: true, label: 'Nitrate Level', name: 'nitrateLevel', description: 'Nitrate Level (N03) mg/l' },
      nitrateChanges: {
        type: 'Number',
        editable: true,
        label: 'Nitrate Changes',
        name: 'nitrateChanges',
        description: 'Amount of change in nitrates (N03) between two periods',
      },
      waterTemperature: { type: 'Number', editable: true, label: 'Water Temperature', name: 'waterTemperature', description: 'Water Temperature (°C)' },
    };
  };
}
